import { gql, Variables } from 'graphql-request';

export interface RemoveCartItemResponse {
  updateViaxCustomerOrder: {
    uid: string;
  };
}

export interface RemoveCartItemInput extends Variables {
  orderUid: string | null;
  removableItemUid: string;
}

export const REMOVE_CART_ITEM_MUTATION = gql`
  mutation removeLineItem($orderUid: String!, $removableItemUid: String!) {
    wRemoveLineItem(orderUid: $orderUid, removableItemUid: $removableItemUid)
  }
`;
